export default {
  name: 'ListProperties',
  props: {
    hotelsAndResorts: { type: Array },
    campsites: { type: Array },
    loadingSkeleton: { type: Object },
  },
  emits: ['focusImage', 'updateProperty'],
  template: `
    <div v-if="hotelsAndResorts.length || loadingSkeleton.hotelsAndResorts" class="properties__row">
      <div class="title">{{ $t('bookingModal.hotelsResorts') }}</div>
      <ul class="no-bullets">
        <li v-for="property in hotelsAndResorts" :key="property.id">
          <button @click="$emit('updateProperty', property)" @mouseover="$emit('focusImage', property.image)">
            <span>{{ property.title }}</span>
            <span class="stars stars--small" :class="'theme--' + property.brand">
              <i v-for="n in property.stars" class="icon-star"></i>
            </span>
          </button>
        </li>
        <li v-for="skeleton in loadingSkeleton.hotelsAndResorts" :key="skeleton">
          <div class="skeleton"></div>
        </li>
      </ul>
    </div>
    <div v-if="campsites.length || loadingSkeleton.campsites" class="properties__row">
      <div class="title">{{ $t('bookingModal.campsites') }}</div>
        <ul class="no-bullets">
          <li v-for="property in campsites" :key="property.id">
            <button @click="$emit('updateProperty', property)" @mouseover="$emit('focusImage', property.image)">
              <span>{{ property.title }}</span>
              <span class="stars stars--small" :class="'theme--' + property.brand">
                <i v-for="n in property.stars" class="icon-star"></i>
              </span>
            </button>
          </li>
          <li v-for="skeleton in loadingSkeleton.campsites" :key="skeleton">
            <div class="skeleton"></div>
          </li>
        </ul>
      </div>
    </div>
  `,
}
